import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'

import '../../asset/less/component.css'

import {Button, Col, message, Row, Typography} from 'antd'
import {getArtistContract, patchArtistContract} from '../../api/artistContracts'
import HttpError from '../../component/base/HttpError'
import {URL_AGREEMENTS} from '../../const'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

@connect((state) => ({
    //decorator, gives component access to the state
    siderWidth: state.style.siderWidth,
    role: state.user.info.role
}))


class SignAgreement extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        let contractId = this.getAgreementId()
        getArtistContract(contractId).then((response) => {
            let url = response.data.sign_url
            if (is_admin_user(this.props)) {
                url = response.data.revart_sign_url
            }
            eversign.open({
                url: url,
                containerID: "request_container",
                width: 1000,
                height: 600,
                events: {
                    loaded: function () {
                        // console.log("loaded Callback");
                    },
                    signed: function (response) {
                        // console.log("signed Callback");
                        this.updateArtistContract(contractId, 'signed')
                    },
                    declined: function (response) {
                        // console.log("declined Callback");
                        his.updateArtistContract(contractId, 'declined')
                    },
                    error: function (response) {
                        // if already signed document is loaded
                        // console.log("Error Callback : " + response);
                    }
                }
            })
        }).catch((error) => {
            HttpError(error)
        })
    }

    updateArtistContract(contractId, status) {
        const params = {}
        const isAdmin = 'artist' //this.props.role
        if (isAdmin === 'admin') {
            if (status === 'signed')
                params['is_signed_revart'] = true
            else if (status === 'declined')
                params['is_declined_revart'] = true
        } else {
            if (status === 'signed')
                params['is_signed'] = true
            else if (status === 'declined')
                params['is_declined'] = true
        }
        patchArtistContract(contractId, params)
            .then((response) => {
                message.success('Signed status has been updated successfully', 1)
                    .then((r) => {
                        this.props.history.push({pathname: URL_AGREEMENTS})
                    })
            })
            .catch((error) => {
                HttpError(error)
            })
    }

    getAgreementId = () => {
        let id = this.props.match.params.id
        if (!id) {
            const locationArray = this.props.location.pathname.split('/')
            if (locationArray[locationArray.length - 1] !== '') {
                id = parseInt(locationArray[locationArray.length - 1])
            } else if (locationArray[locationArray.length - 2] !== '') {
                id = parseInt(locationArray[locationArray.length - 2])
            }
        }
        return id
    }

    render() {
        // console.log('SignAgreement :render')
        return (
            <div>
                <Title level={2} style={{marginBottom: 20}}>
                    Sign Agreement
                </Title>
                <div id='request_container'/>
                {<Row
                    justify='start'
                    style={{
                        padding: 16,
                        bottom: 0,
                        position: 'fixed',
                        zIndex: 1,
                        right: 16,
                        left: 16 + this.props.siderWidth,
                        backgroundColor: 'rgba(255,255,255,0.4)'
                    }}
                >
                    <Col span={6} offset={8}>
                        <Button
                            onClick={(e) => {
                                this.props.history.push({pathname: URL_AGREEMENTS})
                            }}
                            block
                            size='middle'
                            htmlType='submit'
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>}
            </div>
        )
    }
}

export default withRouter(SignAgreement)
